import _ from 'lodash';

import { FetchSettings, ResetValues }
  from 'assets/js/usersettings/functions';
import { ValidateUserSettingArrayOfStrings }
  from 'assets/js/schema/primitives/arrayOfStrings';
import { ValidateUserSettingObject }
  from 'assets/js/schema/primitives/object';

export class UserSettingFactoryArray {
  constructor(store, key) {
    this.store = store;
    this.key = key;
  }

  async get() {
    const value = await FetchSettings({
      store: this.store,
      key: this.key,
      validatorFn: ValidateUserSettingArrayOfStrings,
      defaultData: [],
      resetFn: ResetValues,
    });
    return value;
  }

  // push pushes an element onto the array.
  // TODO:  Is this function ever called? Cannot find a reference to it.
  async push(ctx, value) {
    const currentValue = await this.get(ctx);
    currentValue.push(value);
    await this.set(currentValue);
    return currentValue;
  }

  // pushSet adds an element to the array if it is not already there.
  async pushSet(value) {
    const currentValue = await this.get();
    const asSet = new Set(currentValue);
    asSet.add(value);
    const asArray = Array.from(asSet);
    await this.set(asArray);
    return asArray;
  }

  // remove removes an element from the array.
  async remove(value) {
    const currentValue = await this.get();
    const filteredValue = _.filter(currentValue, (v) => v !== value);
    await this.set(filteredValue);
    return filteredValue;
  }

  // set sets the new value of the array.
  async set(value) {
    ValidateUserSettingArrayOfStrings(value);
    await this.store.dispatch('MutateKeyStore',
      { key: this.key, value });
  }
}

export class UserSettingFactoryObject {
  constructor(store, key) {
    this.store = store;
    this.key = key;
  }

  // get fetches the value of the full object unless it's given a string key,
  // in which case it gets that key nested in the object instead.
  async get(key) {
    const value = await FetchSettings({
      store: this.store,
      key: this.key,
      validatorFn: ValidateUserSettingObject,
      defaultData: {},
      resetFn: ResetValues,
    });

    if (key) return _.get(value, key);
    return value;
  }

  // put writes a value to some key for an object.
  async put(key, value) {
    const currentValue = await this.get();
    const clone = _.cloneDeep(currentValue);
    _.set(clone, key, value);
    await this.set(clone);
    return clone;
  }

  // remove removes an element from the object.
  async remove(key) {
    const currentValue = await this.get();
    const clone = _.cloneDeep(currentValue);
    _.unset(clone, key);
    await this.set(clone);
    return clone;
  }

  // set sets the new value of the object.
  async set(value) {
    ValidateUserSettingObject(value);
    await this.store.dispatch('MutateKeyStore',
      { key: this.key, value });
  }
}
